import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {BaseComponent} from "../../base-component";
import {takeUntil} from "rxjs/operators";
import {HelpService} from "../help.service";

@Component({
  selector: 'app-help-action-bar-buttons',
  templateUrl: './help-action-bar-buttons.component.html',
  styles: [
  ]
})
export class HelpActionBarButtons extends BaseComponent implements OnInit {
  isTopicSelected: boolean = false;
  @Output() saveClick = new EventEmitter<boolean>();
  @Output() editClick = new EventEmitter<boolean>();
  @Output() getUnmodifiedClick = new EventEmitter<boolean>();

  constructor(private route: ActivatedRoute, public helpService: HelpService) {
    super();
  }

  ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.componentDestroyed)).subscribe(params => {
      this.isTopicSelected = !!params.helpId;
    });
  }

}
